export default {
  root: ({ context, props }) => ({
    class: [
      // Font
      'font-sans leading-none',

      // Spacing
      'm-0 p-3',

      // Colors
      'text-neutral-600 dark:text-neutral-200',
      'placeholder:text-neutral-400 dark:placeholder:text-neutral-500',
      'bg-neutral-0 dark:bg-neutral-900',

      'border',
      { 'border-neutral-300/80 dark:border-neutral-600': !props.invalid },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'hover:border-neutral-500 dark:hover:border-neutral-400':
          !context.disabled && !props.invalid,
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-300 focus:border-primary-300 dark:focus:ring-neutral-400/50':
          !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
        'focus:ring-red-500 dark:focus:ring-red-400': props.invalid
      },

      // Misc
      'rounded-md',
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
}
